import { AgGridReact } from 'ag-grid-react';
import {
  AllCommunityModule,
  ModuleRegistry,
  type ColDef,
  type GetRowIdParams,
  type GridApi,
} from 'ag-grid-community';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

// Register all Community features once for the whole app.
ModuleRegistry.registerModules([AllCommunityModule]);

export interface DataGridProps<T> {
  rows: T[];
  columns: ColDef<T>[];
  onRowClick?: (row: T) => void;
  loading?: boolean;
  getRowId?: (row: T) => string;
  height?: number | string;
  quickFilter?: string;
  onGridReady?: (api: GridApi<T>) => void;
}

export function DataGrid<T>({
  rows,
  columns,
  onRowClick,
  loading,
  getRowId,
  height = 540,
  quickFilter,
  onGridReady,
}: DataGridProps<T>) {
  return (
    <div className="ag-theme-alpine" style={{ height, width: '100%' }}>
      <AgGridReact<T>
        theme="legacy"
        rowData={rows}
        columnDefs={columns}
        defaultColDef={{ sortable: true, filter: true, resizable: true, flex: 1, minWidth: 110 }}
        pagination
        paginationPageSize={25}
        paginationPageSizeSelector={[25, 50, 100]}
        animateRows
        loading={loading}
        quickFilterText={quickFilter}
        getRowId={getRowId ? (p: GetRowIdParams<T>) => getRowId(p.data) : undefined}
        onGridReady={onGridReady ? (e) => onGridReady(e.api) : undefined}
        onRowClicked={onRowClick ? (e) => e.data && onRowClick(e.data) : undefined}
        rowStyle={onRowClick ? { cursor: 'pointer' } : undefined}
        overlayNoRowsTemplate="No records found."
      />
    </div>
  );
}

